import React from 'react';
import { AddIntegrationSettings } from 'src/components/Integrations/AddIntegrationPopup/AddIntegrationSettings';
import { useAppSelector } from 'src/store';

export const IntegrationModalStep2 = ({ onSubmit, onBackButton, close }) => {
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const isLastStep = selectedIntegration?.setupSteps === 2;

  return (
    <AddIntegrationSettings
      defaultBtnStyle
      isLastStep={isLastStep}
      onSubmit={onSubmit}
      onBackButton={onBackButton}
      close={close}
    />
  );
};
